import React, { Component } from 'react';
import Spinner from '../../../../reusable-components/Spinner';
import PageHeader from '../../../../reusable-components/PageHeader';
import PageContent from '../../../../reusable-components/PageContent';
import { Map, TileLayer, Marker, Popup, GeoJSON } from 'react-leaflet';
import { Row, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import '../../../../styles/map.less';

function style (feature) {
  return {
    color: feature.properties.DisplayColor,
    weight: 5,
    fillColor: feature.properties.DisplayColor,
    fillOpacity: 1,
    interactive: feature.properties.DisplayColor.toLowerCase() === 'green' ? true : false
  };
}

// highlight on mouseOver
function highlightFeature (e) {
  var layer = e.target;
  var feature = e.target.feature
  if (feature.properties.DisplayColor.toLowerCase() !== 'green') {
    layer.bindPopup("<div style={color: 'white', background: 'red'}><p>You cannot select this location</p></div>");
  }
}

const selectFeature = (component, e) => {
  const layer = e.target;
  layer.bindPopup("<div style={color: 'white', background: 'green'}><p>U heeft deze locatie gekozen</p></div>");
  let lineId = layer.feature.properties.name;
  component.props.saveLineId(lineId)
  component.setState({ btnDisabled: false });
}

function onEachFeature (component, feature, layer) {
  layer.on({
    mouseover: highlightFeature,
    click: selectFeature.bind(null, component)
  });
}

let timeout = null;

export default class LeafletMap extends Component {
  state = {
    lat: 52.379805555555556,
    lng: 4.6362499999999995,
    zoom: 16,
    loadGeojsonData: false,
    errors: null,
    btnDisabled: true,
  }

  componentDidMount() {
    const { fetchGeoJsonData, geoJsonData } = this.props;
    if (!geoJsonData) {
      fetchGeoJsonData();
    }
  }

  componentWillUnmount() {
    clearTimeout(timeout);
  }

  componentWillMount() {
    navigator.geolocation.getCurrentPosition(
        position => {
            var lat = position.coords.latitude,
                lng = position.coords.longitude;
            this.setState({ lat, lng });
        },
        error => console.log(error.message),
        { enableHighAccuracy: true }
    );
  }

  render() {
    const { history, saveLineId, lineId, geoJsonData, isloading } = this.props;
    const position = [this.state.lat, this.state.lng]

    let buttonState = isloading ? <Spinner /> : "Doorgaan";

    return (
      <>
        <PageHeader title="Locatie" />
        <PageContent 
          title="Selecteer de locatie van uw vaartuig, steiger of woonboot"
          goBack={() => this.props.history.goBack()}
          moveNext={() => {
            if (lineId) {
              history.push('/extend/GetObjectDetails')
            } else {
              this.setState({errors: 'Please select a point on the map'})
            }
          }}
          cardClass="card-container"
          showFooter={true}
          hasSubmitBtn={false}
          hasBackBtn={true}
          hasNextBtn={false}
          errors={this.state.errors ? this.state.errors : null}
          buttonState={isloading}
          hasCustomizableNextButton={true}
          btnDisabled={this.state.btnDisabled}>
          <form className="form-bounderless-card form-map-card">
            <Row>
              <Col md={12}>
                <div style={{marginBottom: '10px'}} className="map-container">
                  <Map className="leaflet-map" center={position} zoom={this.state.zoom}>
                    <TileLayer
                      attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    { geoJsonData ? <GeoJSON 
                      data={geoJsonData}
                      style={style}
                      onEachFeature={onEachFeature.bind(null, this)} 
                      key="mygeojsonkeyyy" /> : null }
                  </Map>
                </div>
              </Col>
              {/*<Col md={12}>
                <div className="footer-btn-container">
                  <Button 
                    className="btn back-btn"
                    onClick={() => {
                      this.props.history.goBack();
                    }}>Terug</Button>
                  <Button 
                    className={`btn continue-btn ${this.state.btnDisabled ? 'disabled-btn' : ''}`}
                    disabled={this.state.btnDisabled}
                    onClick={() => {
                      if (lineId) {
                        history.push('/step/two/substep/2')
                      } else {
                        this.setState({errors: 'Please select a point on the map'})
                      }
                    }}>{buttonState}</Button>
                </div>
              </Col>*/}
            </Row>
          </form>
        </PageContent>
      </>
    );
  }
}

